import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import cx from 'classnames';
import React from 'react';
import { WidgetEvents, postToParent } from '../../utils';

const Root = styled('div')`
  cursor: pointer;
  background-color: white;
  overflow: hidden;
  width: 100%;
  height: 70px;
  padding: 10px 70px 10px 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  &.left {
    padding: 10px 30px 10px 70px;
  }
`;

const LauncherText = ({ data, onClick }) => {
  const { text, subtitle, position = 'right' } = data;

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      postToParent(WidgetEvents.LauncherButtonClick);
    }
  };

  return (
    <Root
      onClick={handleClick}
      className={cx({
        left: position === 'left',
      })}
    >
      <Typography
        gutterBottom
        variant="subtitle1"
        fontWeight={700}
        lineHeight={1.2}
      >
        {text}
      </Typography>
      <Typography
        variant="caption"
        fontWeight={500}
        color="text.secondary"
        lineHeight={1}
      >
        {subtitle}
      </Typography>
    </Root>
  );
};

LauncherText.displayName = 'LauncherText';

export default LauncherText;
